import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { WindowToken } from '@app/shared/window.token';
import { TeamFlagsService } from '@app/team/services/team-flags.service';

@Injectable({
  providedIn: 'root',
})
export class TeamViewGuardService  {
  public isAuthorized: boolean;
  constructor(
    private authService: AuthService,
    private teamFlagsService: TeamFlagsService,
    @Inject(WindowToken) private windowRef: Window
  ) {
    const authUser = this.authService.authUser;
    if (authUser?.isSkillInventoryClient || authUser?.isSkillAnalyticsClient) {
      this.isAuthorized = authUser?.isManager;
    } else {
      this.isAuthorized =
        authUser?.isManager &&
        authUser?.defaultOrgInfo?.settings?.enableTeamSpace &&
        (authUser?.defaultOrgInfo?.settings?.skillCoachFullOrgAccess ||
          this.teamFlagsService.teamSpaceEnabled);
    }
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (!this.isAuthorized) {
      this.windowRef.location.assign('/');
    }
    return this.isAuthorized;
  }

  public canLoad() {
    return this.isAuthorized;
  }
}
